"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBUG_REGEX_TEXT = exports.DEBUG_WRAPPER_TEXT = exports.DEBUG_COOKIE_VALUE = exports.DEBUG_COOKIE_NAME = void 0;
exports.DEBUG_COOKIE_NAME = 'string_debug';
exports.DEBUG_COOKIE_VALUE = 'true';
exports.DEBUG_WRAPPER_TEXT = '\u200b'; // Currently set to a zero-width space
exports.DEBUG_REGEX_TEXT = `${exports.DEBUG_WRAPPER_TEXT}(?<intlDebugId>.+?)${exports.DEBUG_WRAPPER_TEXT}`;
//# sourceMappingURL=constants.js.map